// extracted by mini-css-extract-plugin
module.exports = {"headline":"detail_headline__ItZF9","breadcrumbs":"detail_breadcrumbs__uyVKN","heroImage":"detail_heroImage___TBb5"};